<template>
  <a/>
</template>

<script>
import Api from '@/api'
import Entity from '@/api/entity'

export default {
  name: 'ManagesFiles',
  data () {
    return {
      moveModalVisible: false,
      moveModalLoading: false,
      moveTarget: null,
    }
  },
  methods: {
    createNewDirectory (params) {
      return Api.files().createDirectory(params)
    },
    getFilesDataTransferItems (dataTransferItems, uploadPath, moduleIdentifier, parent = null) {
      parent = parent || {}
      return new Promise(async (resolve, reject) => {
        let entriesPromises = []
        for (let it of dataTransferItems) {
          if (it.kind === 'file') {
            const file = it.webkitGetAsEntry()
            entriesPromises.push(
              this.traverseFileTreePromise(file, uploadPath, moduleIdentifier)
            )
          } else {
            entriesPromises.push(
              new Promise((resolve, reject) => {
                it.getAsString(stringData => {
                  let entities
                  try {
                    entities = JSON.parse(stringData)
                  } catch (e) {
                    reject(new Error('Text is not parsable.'))
                    return
                  }
                  if (!entities || entities.length === 0) {
                    reject(new Error('No items in data transfer.'))
                    return
                  }
                  entities.forEach(entity => {
                    entity = new Entity({
                      ...entity,
                      virtual_path: uploadPath,
                      module: moduleIdentifier,
                    })
                    if (parent.directory && parent.id !== entity.id) {
                      Api.saveEntity(entity).then(resolve)
                    } else {
                      reject(new Error(parent.directory ? 'Parent is not a directory.' : 'Cannot drop on self.'))
                    }
                  })
                })
              })
            )
          }
        }
        Promise.allSettled(entriesPromises)
          .then(() => resolve())
          .catch(e => reject(e))
      })
    },
    moveFiles () {
      this.moveModalVisible = false
    },
    traverseFileTreePromise (item, path = '', moduleIdentifier) {
      if (!item) return
      if (item.isFile) {
        return new Promise(resolve => {
          item.file(file => Api.files().uploadFile({
              file: file,
              virtualPath: path,
              module: moduleIdentifier,
            }).then(resolve)
          )
        })
      } else if (item.isDirectory) {
        let dirReader = item.createReader()
        return this.createNewDirectory({
          name: item.name,
          path: path,
          module: moduleIdentifier,
        })
          .then(response => {
            const directory = response.data
            dirReader.readEntries(entries => {
              let entriesPromises = []
              for (let entr of entries) {
                entriesPromises.push(
                  this.traverseFileTreePromise(entr, [directory.virtual_path, directory.name].join('/'), moduleIdentifier)
                )
              }
              return Promise.all(entriesPromises)
            })
          })
      }
    },
  },
}
</script>

<style scoped>

</style>
